// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__1dbDo"};